module.exports = __webpack_public_path__ + "static/media/opacity-icon.194043c2.svg";